// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"452":"ecd937b3","957":"1b327634"}[chunkId] + ".css";
};